import React from "react";
import {
    createOrgUserGroups,
    destroyOrgUserGroups,
    fetchOrganizationUsers,
    fetchUsers, setOrganizationUsers
} from "../../redux/user/Action.js";
import SubmitButton from "../elements/SubmitButton.js";
import DeleteButton from "../elements/DeleteButton.js";
import Button from "@mui/material/Button/Button.js";
import {ColumnDef} from "../table/classes/ColumnDef";
import {Table} from "../../components/table/Table";
import { useSelector, useDispatch } from "react-redux";
import { ADMIN_ROLE, INVITED_ROLE, MEMBER_ROLE, SUPERADMIN_ROLE, CREATE, DESTROY } from "../../utils/Constants.js";
import { memberIsAdmin, memberIsSuperAdmin } from "../../utils/Roles.js";
import "react-widgets/styles.css";
import { updateUserRole, deleteOrganizationUser } from "../../redux/user/Action.js";
import Chip from "@mui/material/Chip/Chip.js";
import Select from "@mui/material/Select/Select.js";
import MenuItem from "@mui/material/MenuItem/MenuItem.js";
import Grid from "@mui/material/Grid/Grid.js";
import OutlinedInput from "@mui/material/OutlinedInput/OutlinedInput.js";
import Box from "@mui/material/Box/Box.js";
import { showConfirmationPopup } from "../../redux/notifications/Action.js";
import {getAlteredGroupdIdAndAction, isNullOrUndefinedOrEmpty} from "../../utils.js";
import "./style.scss";
import {inviteUser} from "../../redux/Actions";
import TextInput from "../elements/TextInput";



const InviteUser = () => {

    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(false);
    const initialState = {
        email: "",
        organization_id: selectedOrganization ? selectedOrganization.id : null,
        first_name: "",
        last_name: ""
    }

    const [formState, setFormState] = React.useState(initialState);
    const [errors, setErrors] = React.useState({});

    const inviteNewUser = () => {
        return dispatch(inviteUser(formState)).then((responseMessage) => {
            return dispatch(fetchUsers({ username: formState.email })).then(fetchedUsers => {
                const createdUser = fetchedUsers[0];
                if (!isNullOrUndefinedOrEmpty(formState.organization_id) && !isNullOrUndefinedOrEmpty(selectedOrganization)) {
                    return dispatch(fetchOrganizationUsers(selectedOrganization.id)).then(fetchedOrganizationUsers => {
                        setLoading(false);
                        return dispatch(setOrganizationUsers(fetchedOrganizationUsers))
                    });
                }
                setLoading(false);
                setFormState(initialState);
            });
        }).catch((errs) => {
            setLoading(false);
            setErrors(errs)
        });
    }

    return <div className="invite-user-form">
        <h2>Invite a Member</h2>
        <TextInput
            id="invite-email"
            name={"email"}
            label="Email"
            type="email"
            formState={formState}
            setFormState={setFormState}
            errors={errors}
            required
        />
        <TextInput
            id="invite-first-name"
            label="First Name"
            name={"first_name"}
            formState={formState}
            setFormState={setFormState}
            errors={errors}
            setErrors={setErrors}
            required
        />
        <TextInput
            id="invite-last-name"
            label="Last Name"
            name={"last_name"}
            formState={formState}
            setFormState={setFormState}
            errors={errors}
            setErrors={setErrors}
            required
        />
        <Button
            id="send-invite-button"
            variant="contained"
            disabled={loading}
            onClick={() => {
                setLoading(true);
                setErrors({});
                inviteNewUser();
            }}>
            {loading ? "Inviting..." : "Send Invite"}
        </Button>
    </div>
}


const MemberTable = ({ loggedInUser, members, groups, onMemberDelete, onMemberUpdate }) => {
    const dispatch = useDispatch();

    const loggedInMember = members.find(m => m.id === loggedInUser.id);
    const organizationUsers = useSelector(state => state.userReducer.loggedInUser.organizationUsers);
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);

    const isAdmin = memberIsAdmin(loggedInMember, organizationUsers, selectedOrganization);
    const isSuperAdmin = memberIsSuperAdmin(loggedInMember, organizationUsers, selectedOrganization);

    const abortController = new AbortController();

    const promoteNewSuperAdmin = (newSuperAdmin, oldSuperAdmin) => {
        const newSuperAdminThroughId = newSuperAdmin.throughId;
        const oldSuperAdminThroughId = members.find(member =>
            member.id === oldSuperAdmin.id
        ).throughId;
        dispatch(updateUserRole(newSuperAdminThroughId, SUPERADMIN_ROLE, "Member promoted.")).then(() => {
            dispatch(updateUserRole(oldSuperAdminThroughId, ADMIN_ROLE, "You have been demoted.")).then(() => {
                onMemberUpdate(newSuperAdmin.id, SUPERADMIN_ROLE);
                onMemberUpdate(oldSuperAdmin.id, ADMIN_ROLE);
            });
        });
    };


    const getUserButtons = (member) => {
        if (!isAdmin) {
            return;
        }

        let deleteButton = null;
        let submitButton = null;

        switch (member.role) {
        case SUPERADMIN_ROLE:
            return;
        case ADMIN_ROLE:
            if (!isSuperAdmin) {
                return;
            }
                
            deleteButton = <DeleteButton
                id={`demote-member-${member.id}`}
                onDelete={() => {
                    dispatch(updateUserRole(member.throughId, MEMBER_ROLE, "Member demoted.")).then(() => {
                        onMemberUpdate(member.id, MEMBER_ROLE);
                    });
                }}>
                    Demote
            </DeleteButton>;

            submitButton = <SubmitButton
                id={`promote-member-${member.id}`}
                onSubmit={() => {
                    dispatch(showConfirmationPopup(
                        "Promote New Superadmin",
                        `Are you sure you want to promote ${member.email} to superadmin? You will then lose your superadmin status.`,
                        () => promoteNewSuperAdmin(member, loggedInUser),
                        () => { },
                        "confirm-promote-superadmin"
                    ));
                }}>
                    Promote
            </SubmitButton >
            return [deleteButton, submitButton];
        case MEMBER_ROLE:
            deleteButton = <DeleteButton
                id={`remove-member-${member.id}`}
                onDelete={() => {
                    dispatch(showConfirmationPopup(
                        "Remove User",
                        `Are you sure you want to remove ${member.email} for this organization?`,
                        () => {
                            dispatch(deleteOrganizationUser(member.throughId)).then(() => {
                                onMemberDelete(member.id);
                            });
                        },
                        () => { },
                        "confirm-remove-user"
                    ));
                }}>
                    Remove
            </DeleteButton>;

            submitButton = <SubmitButton
                id={`promote-member-${member.id}`}
                onSubmit={() => {
                    dispatch(updateUserRole(member.throughId, ADMIN_ROLE, "Member promoted.")).then(() => {
                        onMemberUpdate(member.id, ADMIN_ROLE);
                    });
                }}>
                    Promote
            </SubmitButton>;
            return [deleteButton, submitButton];
        case INVITED_ROLE:
            deleteButton = <DeleteButton
                id={`cancel-invitation-for-member-${member.id}`}
                onDelete={() => {
                    dispatch(deleteOrganizationUser(member.throughId)).then(() => {
                        onMemberDelete(member.id);
                    });
                }}>
                    Cancel Invitation
            </DeleteButton>
            return [deleteButton];
        default:
            return;
        }
    };

    const handleWSPRoleChange = (member, event) => {
        let selectedGroupIds = event.target.value.map(gid => parseInt(gid));
        const memberGroupIds = member.groups.map(group => parseInt(group.id));

        const [alteredGroupId, action] = getAlteredGroupdIdAndAction(selectedGroupIds, memberGroupIds, 1);

        const userGroups = member.groups.filter(group => {
            return selectedGroupIds.find(id => parseInt(id) === parseInt(group.id));
        });

        if (action === CREATE) {
            dispatch(createOrgUserGroups(alteredGroupId, member.throughId, abortController)).then(resp => {
                userGroups.push({
                    ...groups.find(g => parseInt(g.id) === parseInt(resp.group_id)),
                    organizationUserGroupId: resp.id
                });
                onMemberUpdate(member.id, member.role, userGroups);
            });
        } else if (action === DESTROY) {
            const organizationUserGroupId = member.groups.find(oug => {
                return oug.id === alteredGroupId;
            }).organizationUserGroupId;
            dispatch(destroyOrgUserGroups(organizationUserGroupId, abortController)).then(resp => {
                onMemberUpdate(member.id, member.role, userGroups);
            });
        } else {
            console.error("Something went wrong while setting groups.");
        }
    };

    const sortMembersByRole = () => {
        const superAdmin = members.filter(member => { return member.role === SUPERADMIN_ROLE; }).sort((a, b) => {
            return a.email.localeCompare(b.email);
        });
        const admins = members.filter(member => { return member.role === ADMIN_ROLE; }).sort((a, b) => {
            return a.email.localeCompare(b.email);
        });
        const orgMembers = members.filter(member => { return member.role === MEMBER_ROLE; }).sort((a, b) => {
            return a.email.localeCompare(b.email);
        });
        const inviteds = members.filter(member => { return member.role === INVITED_ROLE; }).sort((a, b) => {
            return a.email.localeCompare(b.email);
        });
        const sortedMembers = [...superAdmin, ...admins, ...orgMembers, ...inviteds];
        return sortedMembers;
    };

    const columnDefs = [
        new ColumnDef({displayName: "Email"}),
        new ColumnDef({displayName: "Access Level", options: {sortable: false}}),
        new ColumnDef({displayName: "Roles", options: {sortable: false}})
    ];

    if (members && members.length > 0) {
        return <>
            <InviteUser />
            <h2>Current Members</h2>
            <Table
                columnDefs={columnDefs}
                id={"member-table"}
                data={
                    (Object.values(sortMembersByRole()) || []).map((member, id) => {
                        return [
                            <span id={`member-email-${member.id}`}>{member.email}</span>,
                            <Grid container direction="column" spacing={2}>
                                <Grid id={`member-role-${member.id}`} item xs={12}>
                                    {member.role}
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container direction="row" spacing={2} alignContent={"center"} justifyContent="center">
                                        {Array.isArray(getUserButtons(member)) && getUserButtons(member).map((button, idx) => {
                                            return (
                                                <Grid item key={`member-button-${member.id}-${idx}`}>
                                                    {button}
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Grid>
                            </Grid>,
                            <Select
                                key={member.username + "-roles"}
                                disabled={!(isAdmin || isSuperAdmin)}
                                labelId={member.username + "-roles-label"}
                                id={member.username + "-roles"}
                                multiple
                                value={member.groups.map(group => group.id.toString())}
                                onChange={value => handleWSPRoleChange(member, value)}
                                input={<OutlinedInput id={`select-roles-chip-member-${member.id}`} label="Chip" />}
                                defaultValue={member.groups.map(group => group.id.toString())}
                                renderValue={(selectedGroupIds) => {
                                    return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                        {selectedGroupIds.map((groupId) => {
                                            const group = groups.find(g => parseInt(g.id) === parseInt(groupId));
                                            return <Chip key={group.id.toString()} label={group.name} />;
                                        })}
                                    </Box>;
                                }}>
                                {(groups || []).map((group) => {
                                    return <MenuItem
                                        key={member.username + "-menuitem-" + group.id}
                                        value={group.id.toString()}>{group.name}</MenuItem>;
                                })}
                            </Select>
                        ]
                    })}
            /></>
    }
    return <h2 id='no-members' className="font-bold border-righ text-center mb-4">
        <InviteUser />
        There are currently no members in this organization
    </h2>
};

export default MemberTable;
